<template>
  <v-timeline class="sgptimeline-wrapper">        
    <v-timeline-item
        small
        right
        v-for="(item, index) in items"
        :key="index"
      >
      <template v-slot:opposite>
        <span class="`headline font-weight-bold primary--text`">{{ formataDataBr(item.created_at) }}</span>
      </template>
      <div class="py-4">
        <div class="white pa-4" style="border-radius: 4px; box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);">
          <div style="display: flex; align-items: center; justify-content: space-between;">
            <div style="max-width: 29%; width: 200px;">
              <span>
                <small class="mb-3 grey--text d-block" >
                  <strong>Usuário</strong>
                </small>
                <strong>{{ item.nome }}</strong>
              </span>                
            </div>
            <div class="text-left" style="max-width: 70%; width: 580px; display: flex !important; align-items: center !important; justify-content: space-between !important;">
              <span>
                <small class="mb-3 grey--text" style="display: block;">
                  <strong>Tarefa</strong>
                </small>
                <strong>{{ item.tarefa_origem }}</strong>
              </span> 

              <span class="mr-4" style="width: 25%;">
                <small class="mb-3 grey--text" style="display: block;">
                  <strong>Tratativa</strong>
                </small>
                <strong class="primary--text">{{ item.tratativa }}</strong>
              </span> 
            </div>
          </div>

          <div v-if="['Atualizar', 'Cancelar'].includes(item.tratativa) && item.descricao" class="mt-4 pt-3 alert-info-custom">
            <p class="mb-0 descricao-texto" style="white-space: pre-wrap; word-wrap: break-word;">{{ item.descricao }}</p>
          </div>

          <div v-if="item.pco_tratamentos_formularios && item.pco_tratamentos_formularios.length > 0" class="mt-4">
            <v-expansion-panels flat>
              <v-expansion-panel>
                <v-expansion-panel-header class="pa-0" style="min-height: auto;">
                  <span class="primary--text" style="font-weight: 500; font-size: 14px;">
                    <v-icon small class="mr-2">mdi-file-document-outline</v-icon>
                    Dados do Formulário
                  </span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-for="(formulario, formIdx) in item.pco_tratamentos_formularios" :key="formIdx" class="mt-3">
                    <div v-if="formulario.dados && Object.keys(formulario.dados).length > 0" class="formulario-dados">
                      <v-simple-table dense class="tabela-dados-formulario">
                        <template v-slot:default>
                          <thead>
                            <tr class="header-row">
                              <th class="text-left">Campo</th>
                              <th class="text-left">Valor</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(valor, campo) in formulario.dados" :key="campo">
                              <td class="campo-nome">{{ formatarNomeCampo(campo) }}</td>
                              <td class="campo-valor">{{ valor }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <div v-if="item.anexos && item.anexos.length > 0" class="mt-4">
            <v-expansion-panels flat>
              <v-expansion-panel>
                <v-expansion-panel-header class="pa-0" style="min-height: auto;">
                  <span class="primary--text" style="font-weight: 500; font-size: 14px;">
                    <v-icon small class="mr-2">mdi-paperclip</v-icon>
                    Anexos ({{ item.anexos.length }})
                  </span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div
                    v-for="anexo in item.anexos"
                    :key="anexo.id"
                    class="anexo-item d-flex align-center py-2"
                  >
                    <v-icon small class="mr-2" :color="corAnexo(anexo.mime_type)">{{ iconeAnexo(anexo.mime_type) }}</v-icon>
                    <div class="flex-grow-1">
                      <span class="anexo-nome">{{ anexo.nome_original }}</span>
                      <span class="ml-2 grey--text text--darken-1 caption">&bull; {{ formatarTamanhoAnexo(anexo.tamanho_bytes) }}</span>
                    </div>
                    <v-btn
                      icon
                      small
                      :loading="downloadingId === anexo.id"
                      title="Baixar anexo"
                      @click="baixarAnexo(anexo)"
                    >
                      <v-icon small>mdi-download</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </div>
    </v-timeline-item>
  </v-timeline>
</template>

<script>
// import ReadonlyFormularioComponent from '@/modules/forms/formularios/components/ReadonlyFormularioComponent'
import { formataDataBr } from '@/common/boot/Utils'
import HttpClient from '@/common/boot/HttpClient'
import criarToast from '@/common/boot/ToastsHandler'
export default {
  name: "SGPTimelineHistoricoComponent",
  components: {
    // ReadonlyFormularioComponent
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  data () {
    return {
      painelTarefasPercorridas: 0,
      downloadingId: null
    }
  },

  methods: {
    formataDataBr,

    formatarNomeCampo(nomeCampo) {
      // Converte snake_case para texto legível
      return nomeCampo
        .replace(/_/g, ' ')
        .replace(/\b\w/g, l => l.toUpperCase());
    },

    iconeAnexo(mime) {
      if (!mime) return 'mdi-file-outline';
      if (mime === 'application/pdf') return 'mdi-file-pdf-box';
      if (mime.startsWith('image/')) return 'mdi-file-image';
      if (mime.includes('word') || mime.includes('msword')) return 'mdi-file-word-box';
      if (mime.includes('excel') || mime.includes('spreadsheet')) return 'mdi-file-excel-box';
      if (mime === 'text/plain') return 'mdi-file-document-outline';
      if (mime === 'application/zip' || mime.includes('compressed')) return 'mdi-folder-zip-outline';
      return 'mdi-file-outline';
    },

    corAnexo(mime) {
      if (!mime) return 'grey';
      if (mime === 'application/pdf') return 'red darken-1';
      if (mime.startsWith('image/')) return 'purple';
      if (mime.includes('word') || mime.includes('msword')) return 'blue lighten-1';
      if (mime.includes('excel') || mime.includes('spreadsheet')) return 'green';
      if (mime === 'text/plain') return 'grey darken-1';
      if (mime === 'application/zip' || mime.includes('compressed')) return 'orange';
      return 'grey';
    },

    formatarTamanhoAnexo(bytes) {
      if (!bytes && bytes !== 0) return '';
      if (bytes < 1024) return `${bytes} B`;
      if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
      return `${(bytes / 1048576).toFixed(1)} MB`;
    },

    async baixarAnexo(anexo) {
      this.downloadingId = anexo.id;
      try {
        const response = await HttpClient.get(
          `/pco-tratamentos/anexos/${anexo.id}/download`,
          { responseType: 'blob' }
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', anexo.nome_original);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        criarToast({ tipo: 'error', mensagem: 'Erro ao baixar o anexo.' });
      } finally {
        this.downloadingId = null;
      }
    }
  }
}
</script>

<style lang="scss">

.v-timeline-item {
    display: flex;
    padding-bottom: 24px;
    justify-content: flex-end;
}

.v-timeline-item__opposite {
    flex: 1 1 auto;
    align-self: center;
    max-width: 100px !important;
    width: 100px !important;
}

.v-application--is-ltr .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item--after .v-timeline-item__opposite, .v-application--is-ltr .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item:nth-child(odd):not(.v-timeline-item--before) .v-timeline-item__opposite {
  text-align: center !important; 
}
.v-application--is-ltr .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse):before {
    left: 139px !important;
    right: auto;
}

.v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item--after .v-timeline-item__body, .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item:nth-child(odd):not(.v-timeline-item--before) .v-timeline-item__body {
    max-width: 100% !important;
}

.v-timeline-item__divider {
    position: relative;
    min-width: 80px !important;
    display: flex;
    align-items: center;
    justify-content: center;
}

.alert-info-custom {
  background-color: #e3f2fd;
  border-left: 4px solid #2196f3;
  padding: 12px 16px;
  border-radius: 4px;
  
  strong {
    color: #1976d2;
  }
  
  .descricao-texto {
    color: #1565c0;
    font-size: 14px;
    line-height: 1.6;
    margin-top: 8px;
  }
}

.formulario-dados {
  background-color: #f5f5f5;
  border-radius: 4px;
  padding: 12px;
  margin-top: 8px;
}

.tabela-dados-formulario {
  background-color: white !important;
  border-radius: 4px;
  
  .header-row {
    background-color: #f0f0f0 !important;
    border-bottom: 2px solid #e0e0e0;
    
    th {
      font-weight: 600;
      color: #333;
      padding: 12px 8px !important;
      font-size: 13px;
    }
  }
  
  tbody tr {
    border-bottom: 1px solid #eeeeee;
    
    &:hover {
      background-color: #fafafa !important;
    }
    
    td {
      padding: 10px 8px !important;
      font-size: 13px;
      
      &.campo-nome {
        font-weight: 500;
        color: #555;
        width: 35%;
      }
      
      &.campo-valor {
        color: #333;
        word-break: break-word;
        white-space: pre-wrap;
      }
    }
  }
}

.v-expansion-panel-header {
  min-height: 48px !important;
  
  &:hover {
    background-color: #fafafa;
  }
}

.anexo-item {
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
}

.anexo-nome {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  word-break: break-all;
}
</style>